import { FC } from 'react'

interface DividerProps {
  color?: string
  opacity?: number
}

const Divider: FC<DividerProps> = ({ color, opacity }) => (
  <div
    className={`w-full h-[1px] my-4 shadow ${color === 'dark' ? 'bg-[#6F7880]' : 'bg-primary'}`}
    style={{ opacity: opacity ?? 1 }}
  />
)

export default Divider
